export enum AttributeError {
  EmptyName = "emptyName",
  InvalidFirstChar = "invalidFirstChar",
  InvalidName = "InvalidName",
  DuplicateName = "duplicateName",
}

export const validateAttributeName = (
  attributeName: string,
  attributeNamesSet: Set<string>,
): AttributeError | undefined => {
  if (!attributeName) {
    return AttributeError.EmptyName;
  }
  if (!/[a-zA-Z_]/.test(attributeName[0])) {
    return AttributeError.InvalidFirstChar;
  }
  if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(attributeName)) {
    return AttributeError.InvalidName;
  }
  if (attributeNamesSet.has(attributeName)) {
    return AttributeError.DuplicateName;
  }

  return void 0;
};
